<template>
	<div class="hheader" :class="scrollPosition>10?'hheader-bgwhite':''">
		<div class="header-b">
			<div class="header-l">
				<img src="../assets/logo1.png" alt="">
			</div>
			<div class="header-r">
				<div :class="pathname==item.key?'selectDiv':''" v-for="(item, index) in list"
					@click="taplist(index, item)">
					{{item.name}}
				</div>
			</div>

			<img @click="tapShowMobile" class="header-menu" src="../../public/images/menu.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header',
		props: {
			pathname: {
				type: String,
			}
		},
		watch: {
			pathname(newval, oldval) {
				console.log(newval, oldval, "9999999")
			}
		},
		data() {
			return {
				list: [{
						name: "首页",
						key: "index",
						path: "/index"
					},
					{
						name: "关于中概",
						key: "aboutus",
						path: "/aboutus"
					},
					{
						name: "业务与服务",
						key: "service",
						path: "/service"
					},
					{
						name: "应用场景",
						key: "product",
						path: "/product"
					},
					{
						name: "项目案例",
						key: "case",
						path: "/case"
					},
					{
						name: "新闻媒体",
						key: "medium",
						path: "/medium"
					},
					{
						name: "下载中心",
						key: "download",
						path: "/download"
					},
					{
						name: "联系我们",
						key: "contactus",
						path: "/contactus"
					},
					{
						name: "招贤纳士",
						key: "hire",
						path: "/hire"
					},
					{
						name: "EN",
						key: "en",
						path: "/en"
					},

				],
				scrollPosition:0,
			}
		},
		created() {
			var that = this
			window.addEventListener('scroll', function(){
				 that.scrollPosition = window.scrollY || document.documentElement.scrollTop;
			});
		},
		  beforeDestroy() {
		    window.removeEventListener('scroll', this.handleScroll);
		  },
		  
		
		methods: {
			
			taplist(index, item) {
				console.log(item.key, "111")
				if(item.key == 'en') {
					var currentURL = window.location.href;
					if (currentURL.includes("index")) {
					    this.$router.push("/en")
					}else if (currentURL.includes("about")) {
					    this.$router.push("/en/about")
					}else if (currentURL.includes("service")) {
					    this.$router.push("/en/service")
					}else if (currentURL.includes("product")) {
					    this.$router.push("/en/product")
					}else if (currentURL.includes("case")) {
					    this.$router.push("/en/case")
					}else if (currentURL.includes("medium")) {
					    this.$router.push("/en/medium")
					}else if (currentURL.includes("download")) {
					    this.$router.push("/en/download")
					}else if (currentURL.includes("contactus")) {
					    this.$router.push("/en/contactus")
					}else if (currentURL.includes("hire")) {
					    this.$router.push("/en/hire")
					}else {
					    this.$router.push("/en")
					}
				}else if (item.key == 'index') {
					this.$router.push("/")
				} else {
					this.$router.push(item.key)
				}
			},
			tapShowMobile() {
				console.log("showMobile")
				this.$emit("showMobile", "")
			}
		}
	}
</script>

<style lang="scss">
	.hheader {
		width: 100%;
		// background-color: white;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		color: #332C2B;
		justify-content: center;

		.header-b {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.header-l {}

			.header-r {

				justify-content: flex-end;
				align-items: center;

				div {

					box-sizing: border-box;
					cursor: pointer;
				}

				.selectDiv {
					color: #22A3D3;
					border-bottom: 2px solid #22A3D3;
				}
			}

			.header-menu {
				width: 20px;
				height: 20px;
			}
		}
	}
	.hheader:hover {
		background-color: white;
	}
	.hheader-bgwhite {
		background-color: white;
	}

	@media screen and (min-width: 1200px) {
		.hheader {
			display: flex;
			height: 100px;
			font-size: 16px;

			.header-b {
				width: 1200px;
				height: 100%;

				.header-l {
					width: 20%;
					max-width: 160px;

					img {
						width: 100%;
					}
				}

				.header-r {
					display: flex;
					height: 90px;

					div {
						line-height: 100px;
						height: 100px;
						font-size: 16px;
						margin-left: 20px;
						margin-right: 20px;
					}
				}

				.header-menu {
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.hheader {
			display: flex;
			height: 80px;
			font-size: 15px;

			.header-b {
				width: 100%;
				height: 100%;

				.header-l {
					width: 120px;

					img {
						width: 100%;
					}
				}

				.header-r {
					display: flex;
					height: 100%;

					div {
						line-height: 80px;
						height: 80px;
						font-size: 14px;
						margin-left: 12px;
						margin-right: 12px;
					}
				}

				.header-menu {
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 880px) {
		.hheader {
			padding: 0 12px;
			box-sizing: border-box;
			display: flex;
			height: 50px;
			font-size: 14px;

			.header-b {
				width: 100%;
				height: 100%;

				.header-l {
					width: 80px;

					img {
						width: 100%;
					}
				}

				.header-r {
					display: none;
				}

				.header-menu {
					display: block;
				}
			}
		}
	}


	// @media screen and (min-width: 1200px) {

	// }
	// @media screen and (max-width: 1200px) {

	// }
	// @media screen and (max-width: 880px) {

	// }
</style>
